module.exports = __webpack_public_path__ + "static/media/Cairo-Bold.19a30f18.ttf";